import type { InternalAxiosRequestConfig } from 'axios';
import { getRailsAccessToken } from '../../auth';

export const defaultRailsInterceptor = async (config: InternalAxiosRequestConfig) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  if (config.headers && !config.skipAuth) {
    // TODO one day this will be used from new
    const accessToken = await getRailsAccessToken();
    if (accessToken) {
      // eslint-disable-next-line require-atomic-updates -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }

  return config;
};
